import * as common from './modules/common';
import * as govern from './modules/govern';
import * as address from './modules/address';
import * as pay from './modules/pay';
import * as order from './modules/order';
import * as bill from './modules/bill';
export default {
  ...common,
  ...govern,
  ...address,
  ...pay,
  ...order,
  ...bill,
};
